import { ConsortiumRepoImpl } from "domain/repository/ChargeDetailMaintenance/ConsortiumRepoImpl";
import { CommonAccountRepoImpl } from "domain/repository/CommonAccount/CommonAccountRepoImpl";
import { CompanyRepoImpl } from "domain/repository/Company/CompanyRepoImpl";
import { MasterDataRepoImpl } from "domain/repository/MasterData/MasterDataRepoImpl";
import { useCommonAccountTracked } from "presentation/store/CommonAccount/CommonAccountProvider";
import { CommonAccountVM } from "presentation/viewModel/CommonAccount/CommonAccountVM";
import { useMemo } from "react";

export const useCommonAccountVM = () => {
    const [, setCommonAccountState] = useCommonAccountTracked();
    const commonAccountVM = useMemo(() =>
        CommonAccountVM({
            dispatch: [setCommonAccountState],
            commonAccountRepo: CommonAccountRepoImpl(),
            consortiumRepo: ConsortiumRepoImpl(),
            companyRepo: CompanyRepoImpl(),
            masterDataRepo: MasterDataRepoImpl(),
        }), [setCommonAccountState])

    return commonAccountVM
}